<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/Text/Hardesty0007#loi">List of Figures and Tables</a></p>
<p class="tocfm"><a class="xref" href="#/Text/Hardesty0008#acknow">Acknowledgments</a></p>
<p class="toc"><a class="xref" href="#/Text/Hardesty0009#ch01">Introduction: A World of Unfreedom</a></p>
<p class="toc"><a class="xref" href="#/Text/Hardesty0010#ch02">1. Origins</a></p>
<p class="toc"><a class="xref" href="#/Text/Hardesty0011#ch03">2. Deference and Dependence</a></p>
<p class="toc"><a class="xref" href="#/Text/Hardesty0012#ch04">3. Social Worlds</a></p>
<p class="toc"><a class="xref" href="#/Text/Hardesty0013#ch05">4. Laboring Lives</a></p>
<p class="toc"><a class="xref" href="#/Text/Hardesty0014#ch06">5. Appropriating Institutions</a></p>
<p class="toc"><a class="xref" href="#/Text/Hardesty0015#ch07">Afterword: The Fall of the House of Unfreedom</a></p>
<p class="tocfm"><br/></p>
<p class="tocfm"><a class="xref" href="#/Text/Hardesty0016#notes">Notes</a></p>
<p class="tocfm"><a class="xref" href="#/Text/Hardesty0017#index">Index</a></p>
<p class="tocfm"><a class="xref" href="#/Text/Hardesty0018#aubio">About the Author</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hardesty-0006.vue?1a1b9130